<template>
  <Layout style="min-height: 90vh">
    <Layout>
      <Content>
        <Row style="margin-top:3px;" type="flex" justify="space-around">
          <Col :md="5" :xs="11">
            <Card :padding="0">
              <Row>
                <Col
                  span="10"
                  :style="`background-color: #2D8CF0; color: white; text-align: center; ${$mq == 'lg' ? 'height: 150px;' : 'height: 90px;'}`"
                >
                  <p
                    :style="`font-weight: bold; ${$mq == 'lg' ? 'margin-top: 40%;' : 'margin-top: 35%;'}`"
                  >
                    <Icon
                      :style="$mq == 'lg' ? 'font-size: 30px;' : 'font-size: 20px;'"
                      type="md-cloud-done"
                    ></Icon>
                    <br />
                    <span :style="$mq == 'lg' ? 'font-size: 20px;' : 'font-size: 15px;'">Published</span>
                  </p>
                </Col>
                <Col span="14">
                  <center>
                    <i-circle
                      :percent="(published / tier) * 100"
                      dashboard
                      :size="$mq == 'lg' ? 130 : 70"
                      stroke-color="#2D8CF0"
                      :style="$mq == 'lg' ? 'margin-top: 10px;' : ' margin-top: 12px;'"
                    >
                      <span
                        class="demo-Circle-inner"
                        :style="`font-weight: bold; ${$mq == 'lg' ? 'font-size: 25px;' : 'font-size: 15px;'}`"
                      >{{ published }}/{{ tier }}</span>
                    </i-circle>
                  </center>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col :md="5" :xs="11">
            <Card :padding="0">
              <Row>
                <Col
                  span="10"
                  :style="`background-color: #5CB85C; color: white; text-align: center; ${$mq == 'lg' ? 'height: 150px;' : 'height: 90px;'}`"
                >
                  <p
                    :style="`font-weight: bold; ${$mq == 'lg' ? 'margin-top: 25%;' : 'margin-top: 15%;'}`"
                  >
                    <Icon
                      :style="$mq == 'lg' ? 'font-size: 30px;' : 'font-size: 20px;'"
                      type="md-cloud-upload"
                    ></Icon>
                    <br />
                    <span
                      :style="$mq == 'lg' ? 'font-size: 20px;' : 'font-size: 15px;'"
                    >Daily uploaded</span>
                  </p>
                </Col>
                <Col span="14">
                  <center>
                    <i-circle
                      :percent="((dailyUpload - remaining) / dailyUpload) * 100"
                      dashboard
                      :size="$mq == 'lg' ? 130 : 70"
                      stroke-color="#5CB85C"
                      :style="$mq == 'lg' ? 'margin-top: 10px;' : 'margin-top: 12px;'"
                    >
                      <span
                        class="demo-Circle-inner"
                        :style="`font-weight: bold; ${$mq == 'lg' ? 'font-size: 25px;' : 'font-size: 15px;'}`"
                      >{{ dailyUpload - remaining }}/{{ dailyUpload }}</span>
                    </i-circle>
                  </center>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col :md="5" :xs="11">
            <Card :padding="0">
              <Row>
                <Col
                  span="10"
                  :style="`background-color: #FFD572; color: white; text-align: center; ${$mq == 'lg' ? 'height: 150px;' : 'height: 90px;'}`"
                >
                  <p
                    :style="`font-weight: bold; ${$mq == 'lg' ? 'margin-top: 40%;' : 'margin-top: 35%;'}`"
                  >
                    <Icon
                      :style="$mq == 'lg' ? 'font-size: 30px;' : 'font-size: 20px;'"
                      type="md-warning"
                    ></Icon>
                    <br />
                    <span :style="$mq == 'lg' ? 'font-size: 20px;' : 'font-size: 15px;'">Rejected</span>
                  </p>
                </Col>
                <Col span="14">
                  <p
                    :style="`color: #FFD572; text-align: center; ${$mq == 'lg' ? 'font-size: 69px; margin-top: 15%;' : 'font-size: 58px;'}`"
                  >{{ reject }}</p>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col :md="5" :xs="11">
            <Card :padding="0">
              <Row>
                <Col
                  span="10"
                  :style="`background-color: #F25E43; color: white; text-align: center; ${$mq == 'lg' ? 'height: 150px;' : 'height: 90px;'}`"
                >
                  <p
                    :style="`font-weight: bold; ${$mq == 'lg' ? 'margin-top: 40%;' : 'margin-top: 35%;'}`"
                  >
                    <Icon
                      :style="$mq == 'lg' ? 'font-size: 30px;' : 'font-size: 20px;'"
                      type="md-trash"
                    ></Icon>
                    <br />
                    <span :style="$mq == 'lg' ? 'font-size: 20px;' : 'font-size: 15px;'">Removed</span>
                  </p>
                </Col>
                <Col span="14">
                  <p
                    :style="`color: #F25E43; text-align: center; ${$mq == 'lg' ? 'font-size: 69px; margin-top: 15%;' : 'font-size: 58px;'}`"
                  >{{ remove }}</p>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row style="margin-top:10px;" type="flex" justify="space-around">
          <Col span="23" class="tabs-style">
            <Tabs type="card">
              <TabPane label="Sales per day" icon="ios-cart">
                <RadioGroup
                  style="margin-right: 10px;"
                  type="button"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                >
                  <Radio
                    label="last7Days"
                    @click.native="salesPerDayDateRangeInput = last7Days; getSalesPerDay()"
                  >Last 7 days</Radio>
                  <Radio
                    label="thisMonth"
                    @click.native="salesPerDayDateRangeInput = thisMonth; getSalesPerDay()"
                  >This month</Radio>
                  <Radio
                    label="lastMonth"
                    @click.native="salesPerDayDateRangeInput = lastMonth; getSalesPerDay()"
                  >Last month</Radio>
                </RadioGroup>
                <Br v-if="$mq != 'lg'" />
                <DatePicker
                  transfer
                  :disabled="$mq == 'lg' ? false : true"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                  type="daterange"
                  v-model="salesPerDayDateRangeInput"
                  placement="right"
                  placeholder="Select date"
                  :style="`width: 200px; ${$mq == 'lg' ? '' : 'margin-top: 3px;'}`"
                  @on-change="getSalesPerDay"
                ></DatePicker>
                <apexchart
                  :key="keySalesPerDayNumber"
                  :height="300"
                  type="line"
                  :options="options"
                  :series="series"
                ></apexchart>
              </TabPane>
              <TabPane label="Sales per account" icon="ios-cart">
                <RadioGroup
                  style="margin-right: 10px;"
                  type="button"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                >
                  <Radio
                    label="yesterday"
                    @click.native="accountDateRangeInput = yesterday; getAccountReport()"
                  >Yesterday</Radio>
                  <Radio
                    label="last7Days"
                    @click.native="accountDateRangeInput = last7Days; getAccountReport()"
                  >{{$mq == 'lg' ? 'Last 7 days' : '7D'}}</Radio>
                  <Radio
                    label="thisMonth"
                    @click.native="accountDateRangeInput = thisMonth; getAccountReport()"
                  >{{$mq == 'lg' ? 'This month' : 'TM'}}</Radio>
                  <Radio
                    label="lastMonth"
                    @click.native="accountDateRangeInput = lastMonth; getAccountReport()"
                  >{{$mq == 'lg' ? 'Last month' : 'LM'}}</Radio>
                  <Radio
                    label="allTime"
                    @click.native="accountDateRangeInput = allTime; getAccountReport()"
                  >{{$mq == 'lg' ? 'All time' : 'All'}}</Radio>
                </RadioGroup>
                <Br v-if="$mq != 'lg'" />
                <DatePicker
                  transfer
                  :disabled="$mq == 'lg' ? false : true"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                  type="daterange"
                  v-model="accountDateRangeInput"
                  placement="right"
                  placeholder="Select date"
                  :style="`width: 200px; ${$mq == 'lg' ? '' : 'margin-top: 3px;'}`"
                  @on-change="getAccountReport"
                ></DatePicker>
                <Table
                  border
                  :columns="$mq == 'lg' ? accountReportTitle : accountReportTitleResponsive"
                  :data="accountReport"
                  :row-class-name="rowClassName"
                  style="margin-top: 10px;"
                >
                  <template slot-scope="{ row, index }" slot="account">
                    <p v-if="row.account">
                      Acc {{ row.account[0].number }}
                      <br />
                      {{ row.account[0].username }}
                    </p>
                    <strong v-else>Total</strong>
                  </template>
                </Table>
              </TabPane>
              <TabPane label="Designs" icon="ios-cart">
                <RadioGroup
                  style="margin-right: 10px;"
                  type="button"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                >
                  <Radio
                    label="yesterday"
                    @click.native="designDateRangeInput = yesterday; getDesignReport()"
                  >Yesterday</Radio>
                  <Radio
                    label="last7Days"
                    @click.native="designDateRangeInput = last7Days; getDesignReport()"
                  >{{$mq == 'lg' ? 'Last 7 days' : '7D'}}</Radio>
                  <Radio
                    label="thisMonth"
                    @click.native="designDateRangeInput = thisMonth; getDesignReport()"
                  >{{$mq == 'lg' ? 'This month' : 'TM'}}</Radio>
                  <Radio
                    label="lastMonth"
                    @click.native="designDateRangeInput = lastMonth; getDesignReport()"
                  >{{$mq == 'lg' ? 'Last month' : 'LM'}}</Radio>
                  <Radio
                    label="allTime"
                    @click.native="designDateRangeInput = allTime; getDesignReport()"
                  >{{$mq == 'lg' ? 'All time' : 'All'}}</Radio>
                </RadioGroup>
                <Br v-if="$mq != 'lg'" />
                <DatePicker
                  transfer
                  :disabled="$mq == 'lg' ? false : true"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                  type="daterange"
                  v-model="designDateRangeInput"
                  placement="right"
                  placeholder="Select date"
                  :style="`width: 200px; ${$mq == 'lg' ? '' : 'margin-top: 3px;'}`"
                  @on-change="getDesignReport"
                ></DatePicker>
                <Table
                  border
                  :columns="$mq == 'lg' ? designReportTitle : designReportTitleResponsive"
                  :data="designReport"
                  style="margin-top: 10px;"
                >
                  <template slot-scope="{ row, index }" slot="design">
                    <p>
                      <a
                        :href="'https://www.amazon.com/dp/' + row.design[0].productId"
                        target="_blank"
                      >{{ row.design[0].title }}</a>
                    </p>
                  </template>
                </Table>
              </TabPane>
              <TabPane label="Designers" icon="ios-cart">
                <RadioGroup
                  style="margin-right: 10px;"
                  type="button"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                >
                  <Radio
                    label="yesterday"
                    @click.native="designerDateRangeInput = yesterday; getDesignerReport()"
                  >Yesterday</Radio>
                  <Radio
                    label="last7Days"
                    @click.native="designerDateRangeInput = last7Days; getDesignerReport()"
                  >{{$mq == 'lg' ? 'Last 7 days' : '7D'}}</Radio>
                  <Radio
                    label="thisMonth"
                    @click.native="designerDateRangeInput = thisMonth; getDesignerReport()"
                  >{{$mq == 'lg' ? 'This month' : 'TM'}}</Radio>
                  <Radio
                    label="lastMonth"
                    @click.native="designerDateRangeInput = lastMonth; getDesignerReport()"
                  >{{$mq == 'lg' ? 'Last month' : 'LM'}}</Radio>
                  <Radio
                    label="allTime"
                    @click.native="designerDateRangeInput = allTime; getDesignerReport()"
                  >{{$mq == 'lg' ? 'All time' : 'All'}}</Radio>
                </RadioGroup>
                <Br v-if="$mq != 'lg'" />
                <DatePicker
                  transfer
                  :disabled="$mq == 'lg' ? false : true"
                  :size="$mq == 'lg' ? 'default' : 'small'"
                  type="daterange"
                  v-model="designerDateRangeInput"
                  placement="right"
                  placeholder="Select date"
                  :style="`width: 200px; ${$mq == 'lg' ? '' : 'margin-top: 3px;'}`"
                  @on-change="getDesignerReport"
                ></DatePicker>
                <Table
                  border
                  :columns="$mq == 'lg' ? designerReportTitle : designerReportTitleResponsive"
                  :data="designerReport"
                  style="margin-top: 10px;"
                >
                  <template slot-scope="{ row, index }" slot="_id">
                    <p>{{ row._id.name }}</p>
                  </template>
                </Table>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import api from '@/api'

import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'home',
  components: {
    apexchart: VueApexCharts
  },
  data: () => {
    return {
      keySalesPerDayNumber: 0,
      tier: 0,
      published: 0,
      dailyUpload: 0,
      remaining: 0,
      reject: 0,
      remove: 0,
      options: {
        chart: {
          id: 'sales-per-day',
          type: 'line',
          stacked: false
        },
        colors: ['#2E93fA', '#FEB019', '#FF4560', '#00E396'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [3, 3, 3, 3]
        },
        title: {
          text: '',
          align: 'central',
          offsetX: 0
        },
        markers: {
          size: 3
        },
        yaxis: [
          {
            seriesName: 'Purchased',
            // decimalsInFloat: Number,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true
            },
            title: {
              text: 'Purchased - Cancelled - Returned'
            }
          },
          {
            seriesName: 'Cancelled',
            show: false
          },
          {
            seriesName: 'Returned',
            show: false
          },
          {
            seriesName: 'Royalties',
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true
            },
            title: {
              text: 'Royalties ($)'
            }
          }
        ],
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      },
      series: [
        {
          name: 'Purchased',
          type: 'line',
          data: []
        },
        {
          name: 'Cancelled',
          type: 'line',
          data: []
        },
        {
          name: 'Returned',
          type: 'line',
          data: []
        },
        {
          name: 'Royalties',
          type: 'line',
          data: []
        }
      ],
      user: {},
      accountReportTitle: [
        {
          title: 'Account',
          slot: 'account',
          width: '550px'
        },
        {
          title: 'Purchased',
          key: 'purchased'
        },
        {
          title: 'Cancelled',
          key: 'cancelled'
        },
        {
          title: 'Returned',
          key: 'returned'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      accountReportTitleResponsive: [
        {
          title: 'Account',
          slot: 'account',
          width: '250px'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      designerReport: [],
      designReportTitle: [
        {
          title: 'Design',
          slot: 'design',
          width: '550px'
        },
        {
          title: 'Purchased',
          key: 'purchased'
        },
        {
          title: 'Cancelled',
          key: 'cancelled'
        },
        {
          title: 'Returned',
          key: 'returned'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      designReportTitleResponsive: [
        {
          title: 'Design',
          slot: 'design',
          width: '250px'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      accountReport: [],
      designerReportTitle: [
        {
          title: 'Designer',
          slot: '_id',
          width: '340px'
        },
        {
          title: 'Score',
          key: 'designScore'
        },
        {
          title: 'Purchased',
          key: 'purchased'
        },
        {
          title: 'Cancelled',
          key: 'cancelled'
        },
        {
          title: 'Returned',
          key: 'returned'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      designerReportTitleResponsive: [
        {
          title: 'Designer',
          slot: '_id'
        },
        {
          title: 'Score',
          key: 'designScore'
        },
        {
          title: 'Royalties',
          key: 'royalties'
        }
      ],
      designReport: [],
      salesPerDayDateRangeInput: [],
      accountDateRangeInput: [],
      designerDateRangeInput: [],
      designDateRangeInput: []
    }
  },
  created: function() {
    this.user = this.$store.state.auth.user
  },
  async mounted() {
    this.salesPerDayDateRangeInput = this.thisMonth
    this.designDateRangeInput = this.thisMonth
    this.accountDateRangeInput = this.thisMonth
    this.designerDateRangeInput = this.thisMonth

    this.getAccountsStatus()
    this.getSalesPerDay()
    this.getAccountReport()
    this.getDesignerReport()
    this.getDesignReport()
  },
  computed: {
    today: function() {
      let now = new Date()
      now.setUTCHours(0, 0, 0, 0)
      return now
    },
    yesterday: function() {
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      yesterday.setUTCHours(0, 0, 0, 0)
      return [yesterday, this.today]
    },
    last7Days: function() {
      let last7Days = new Date()
      last7Days.setDate(last7Days.getDate() - 7)
      last7Days.setUTCHours(0, 0, 0, 0)
      return [last7Days, this.today]
    },
    thisMonth: function() {
      let date = new Date()
      let thisYear = date.getFullYear()
      let thisMonth = date.getMonth()
      let startThisMonth = new Date(thisYear, thisMonth, 2)
      startThisMonth.setUTCHours(0, 0, 0, 0)
      let endThisMonth = new Date(thisYear, thisMonth + 1, 1)
      endThisMonth.setUTCHours(0, 0, 0, 0)
      return [startThisMonth, endThisMonth]
    },
    lastMonth: function() {
      let date = new Date()
      let thisYear = date.getFullYear()
      let thisMonth = date.getMonth()
      let startLastMonth = new Date(thisYear, thisMonth - 1, 2)
      startLastMonth.setUTCHours(0, 0, 0, 0)
      let endLastMonth = new Date(thisYear, thisMonth, 1)
      endLastMonth.setUTCHours(0, 0, 0, 0)
      return [startLastMonth, endLastMonth]
    },
    allTime: function() {
      let start = new Date('2019-1-2')
      start.setUTCHours(0, 0, 0, 0)
      return [start, this.today]
    }
  },
  methods: {
    rowClassName(row, index) {
      if (index === this.accountReport.length - 1) {
        return 'table-summary-row'
      }
      return ''
    },
    getAccountsStatus() {
      this.$store.dispatch('fetchAccounts').then(accounts => {
        for (let i = 0; i < accounts.data.length; i++) {
          if (accounts.data[i].tier && !accounts.data[i].isTerminated) {
            this.tier = this.tier + accounts.data[i].tier
            this.dailyUpload =
              this.dailyUpload + Math.round(accounts.data[i].tier / 4)
          }

          if (accounts.data[i].published && !accounts.data[i].isTerminated) {
            this.published = this.published + accounts.data[i].published
          }

          let today = new Date()

          if (
            accounts.data[i].remaining &&
            accounts.data[i].lastUploadDate &&
            !accounts.data[i].isTerminated
          ) {
            let lastUploadDate = new Date(accounts.data[i].lastUploadDate)
            if (
              lastUploadDate.getDate() == today.getDate() &&
              lastUploadDate.getMonth() == today.getMonth() &&
              lastUploadDate.getFullYear() == today.getFullYear()
            ) {
              this.remaining = this.remaining + accounts.data[i].remaining
            } else {
              this.remaining =
                this.remaining + Math.round(accounts.data[i].tier / 4)
            }
          }
        }
      })

      api({
        method: 'get',
        url: 'reports/scars'
      })
        .then(res => {
          this.reject = res.data.reject
          this.remove = res.data.remove
        })
        .catch(error => {
          this.$Message.error('Get scars report error: ' + error.message)
        })
    },
    getSalesPerDay() {
      let startRange = this.salesPerDayDateRangeInput[0].toISOString()
      let endRange = this.salesPerDayDateRangeInput[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/salesperday' + queryString
      })
        .then(res => {
          let label = []
          let purchased = []
          let returned = []
          let cancelled = []
          let royalties = []
          for (let i = 0; i < res.data.length; i++) {
            label.push(
              res.data[i]._id.day.toString() +
                '/' +
                res.data[i]._id.month.toString()
            )
            purchased.push(res.data[i].purchased)
            cancelled.push(res.data[i].cancelled)
            returned.push(res.data[i].returned)
            royalties.push(res.data[i].royalties.toFixed(2))
          }
          this.options.xaxis = { categories: label }
          let maxYaxis = Math.max(...[...purchased, ...cancelled, ...returned])
          for (let yaxis of this.options.yaxis) {
            if (yaxis.seriesName !== 'Royalties') yaxis.max = maxYaxis
          }

          this.series = [
            {
              name: 'Purchased',
              type: 'line',
              data: purchased
            },
            {
              name: 'Cancelled',
              type: 'line',
              data: cancelled
            },
            {
              name: 'Returned',
              type: 'line',
              data: returned
            },
            {
              name: 'Royalties',
              type: 'line',
              data: royalties
            }
          ]

          this.keySalesPerDayNumber = this.keySalesPerDayNumber + 1
        })
        .catch(error => {
          this.$Message.error('Get sale per day report error: ' + error.message)
        })
    },
    getAccountReport() {
      let startRange = this.accountDateRangeInput[0].toISOString()
      let endRange = this.accountDateRangeInput[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/accounts' + queryString
      })
        .then(res => {
          this.accountReport = res.data.rows
        })
        .catch(error => {
          this.$Message.error('Get accounts report error: ' + error.message)
        })
    },
    getDesignReport() {
      let startRange = this.designDateRangeInput[0].toISOString()
      let endRange = this.designDateRangeInput[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/designs' + queryString
      })
        .then(res => {
          this.designReport = res.data.rows
        })
        .catch(error => {
          this.$Message.error('Get designs report error: ' + error.message)
        })
    },
    getDesignerReport() {
      let startRange = this.designerDateRangeInput[0].toISOString()
      let endRange = this.designerDateRangeInput[1].toISOString()
      let queryString = '?limit=100&date>=' + startRange + '&date<=' + endRange
      api({
        method: 'get',
        url: 'reports/designers' + queryString
      })
        .then(res => {
          this.designerReport = res.data
        })
        .catch(error => {
          this.$Message.error('Get designers report error: ' + error.message)
        })
    }
  },
  watch: {}
}
</script>
<style>
.tabs-style > .ivu-tabs-card > .ivu-tabs-content {
  margin-top: -16px;
}

.tabs-style > .ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.tabs-style > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-color: transparent;
}

.tabs-style > .ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  border-color: #fff;
}
.ivu-table .table-summary-row td {
  background-color: #f8f8f9;
  font-weight: bold;
}
</style>
